import { BoostAdFlagType } from '@zg-rentals/ts-rental-manager-api-client';
import { Box, Icon, PropertyCard, Text, TextButton } from '@zillow/constellation-10';
import { IconExternalFilled } from '@zillow/constellation-icons';
import { styled } from '@/styled-system/jsx';
import { getDefaultRentStartingAt } from './BoostWidget';

export interface ZillowAdPreviewProps {
  adFlag: BoostAdFlagType;
  customFlag: string;
  imageSrc: string;
  title: string;
  subheader: string;
  rentStartingAtPrice: number;
  websiteLink: string;
  displayRentStartingAt: boolean;
  customDetails: string;
}

const StyledPropertyCard = styled(PropertyCard, {
  base: {
    minWidth: '100% !important',
    height: 'min-content !important',
    boxShadow: 'none',
    border: '1px solid',
    borderColor: 'gray.300',
    borderRadius: '4px',
    '& a': {
      color: 'blue.400',
      marginTop: 0,
    },
  },
});

const CustomBadge = styled(PropertyCard.Badge, {
  base: {
    height: 'min-content',
    textTransform: 'capitalize',
  },
  variants: {
    addMargin: {
      true: {
        marginTop: 'sm',
        marginRight: 'sm',
      },
    },
  },
});

export const ZillowAdPreview = ({
  imageSrc,
  adFlag,
  customFlag,
  rentStartingAtPrice,
  subheader,
  title,
  websiteLink,
  displayRentStartingAt,
  customDetails,
}: ZillowAdPreviewProps) => {
  return (
    <>
      <StyledPropertyCard
        aria-label={title}
        badge={
          adFlag !== BoostAdFlagType.NONE && (
            <CustomBadge css={{ marginTop: '150' }}>
              {adFlag === BoostAdFlagType.CUSTOM
                ? customFlag || '1 month free'
                : adFlag.replace(/_/g, ' ').toLowerCase()}
            </CustomBadge>
          )
        }
        data={{
          dataArea1: title,
          dataArea2: subheader ? (
            <PropertyCard.HomeDetails data={subheader.split(',').map((val) => ({ value: '', label: val.trim() }))} />
          ) : undefined,
          dataArea3: displayRentStartingAt ? getDefaultRentStartingAt(rentStartingAtPrice) : (customDetails ?? ''),
          dataArea5: websiteLink ? (
            <Box>
              <TextButton asChild>
                <a href={websiteLink} target="_blank" rel="noopener noreferrer">
                  <Box css={{ display: 'flex', alignItems: 'center', gap: 'xs' }}>
                    <Text textStyle="body-sm-bold" css={{ color: 'blue.400' }}>
                      Visit website
                    </Text>
                    <Icon css={{ color: 'blue.400' }}>
                      <IconExternalFilled />
                    </Icon>
                  </Box>
                </a>
              </TextButton>
            </Box>
          ) : undefined,
        }}
        photoBody={<PropertyCard.Photo src={imageSrc} alt={title} />}
        saveButton={<CustomBadge addMargin>Sponsored</CustomBadge>}
        elevated={false}
      />
    </>
  );
};
